const UserAuthType = {
  Internal: 1,
  External: 2,
  ServiceAccount: 3,
};
export default UserAuthType;
